import { ref, reactive } from "vue";

export function useFormData() {
  const formData = reactive({
    // nombres: "Luis Enrique",
    // apellidos: "Robledo Bonilla",
    // email: "strato0100@gmail.com",
    // fechaNacimiento: "1985-05-26",
    // telefonoUSA: "+1 123-456-7890",
    nombres: "",
    apellidos: "",
    email: "",
    fechaNacimiento: "",
    telefonoUSA: "",
    zipCode: "",
    estado: "",
    ciudad: "",
    // ingresosMensuales: 3500,
    ingresosMensuales: 0,
    // montoCredito: 9000,
    montoCredito: 0,
    // usReferences: [{ nombre: "US Reference", telefono: "+1 123-456-7890" }],
    usReferences: [{ nombre: "", telefono: "" }],
    // guatemalaReferences: [
    //   { nombre: "Guatemala Reference", telefono: "+502 5218-6543" },
    // ],
    guatemalaReferences: [{ nombre: "", telefono: "" }],
    // tipoDocumento: "dpi",
    tipoDocumento: "",
    // numeroDocumento: "2528360220101",
    numeroDocumento: "",
    documentoFrontal: null,
    documentoTrasero: null,
    comprobanteDomicilio: null,
    selfie: null,
  });

  const updateFormData = (field, value) => {
    formData[field] = value;
  };

  const resetForm = () => {
    Object.assign(formData, {
      nombres: "",
      apellidos: "",
      email: "",
      fechaNacimiento: "",
      telefonoUSA: "",
      zipCode: "",
      estado: "",
      ciudad: "",
      ingresosMensuales: 0,
      montoCredito: 0,
      usReferences: [{ nombre: "", telefono: "" }],
      guatemalaReferences: [{ nombre: "", telefono: "" }],
      tipoDocumento: "",
      numeroDocumento: "",
      documentoFrontal: null,
      documentoTrasero: null,
      comprobanteDomicilio: null,
      selfie: null,
    });
  };

  return {
    formData,
    updateFormData,
    resetForm,
  };
}
